// extracted by mini-css-extract-plugin
export default {"message":"FLL86fX7vIo7FLqy7+lwa2RR9zvTC1KSVvuNMJbfpiA=","messageIcon":"aMLJRow8W3-tQX6pLI544s0cjtJNymxbma-rO3AJzHg="};